<!--队员积分录入-->
<template lang="pug">
    el-dialog(title="队员积分录入", width="60%", :visible.sync='visible' :append-to-body="true" @close="closeForm()")
        div
            font 俱乐部名称:{{ club.name }}
        div(class="container")
            div(v-for="item of clubMember" :key="item.mbId" class="childContainer")
                div
                    font {{ item.mbName }}积分
                div
                    <el-input-number v-model="item.score" :min="0" :max="1000000" label="描述文字"></el-input-number>
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="confirmScoreInput") 确 定
            el-button(@click="closeForm()") 取 消
</template>
<script>
    export default {
        name: 'MemberInput',
        data () {
            return {
                visible: false,
                club: '', // 俱乐部信息
                competId: '', // 比赛ID
                clubMember: []
            }
        },
        methods: {
            init (row, gameId) {
                this.visible = true
                this.club = row
                this.competId = gameId
                this.clubMember = [] // 置空
                this.$http({
                    url: this.$http.adornUrl(`/elEnrollOrder/contestant/${this.competId}/${this.club.participantInfoId}`),
                    method: 'get'
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.clubMember = data.data
                    } else {
                        this.clubMember = []
                    }
                })
            },
            confirmScoreInput () {
                // 入参，数据组装
                 let memberInputParams = { memberScoreList: [], businessId: '' }
                 memberInputParams.businessId = this.competId // 俱乐部ID
                 this.clubMember.map(ele => {
                     let param = { level: ele.memberLevel, memberId: ele.mbId, points: ele.score }
                     memberInputParams.memberScoreList.push(param)
                 })
                 this.$http({
                    url: this.$http.adornUrl(`/mbScore/saveClubMemberPoints`),
                    method: 'post',
                    data: memberInputParams
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.visible = false
                    } else {
                        this.$message.warning(data.msg)
                    }
                })
            },
            closeForm () {
                this.visible = false
            }
        }
    }
</script>
<style scoped>
.container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
}
.childContainer {
    width: 40%;
    margin-bottom: 20px;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-around;
}

</style>
